// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__22wyI","tab":"ProcedureTabs_tab__1jwLZ"};